
const apiConfig = {
                baseURL: "https://api.betwinzone.net",
            //  baseURL: "http://localhost:5000",
};

export default apiConfig;